import { render, staticRenderFns } from "./lc-editor-stage.vue?vue&type=template&id=99ed4a7c"
import script from "./lc-editor-stage.vue?vue&type=script&lang=js"
export * from "./lc-editor-stage.vue?vue&type=script&lang=js"
import style0 from "./lc-editor-stage.vue?vue&type=style&index=0&id=99ed4a7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports